import { ROLES } from '../../../../../constants';

import permissionsActiveIcon from '../../assets/icons/blue/view_permissions.svg';
import permissionsIcon from '../../assets/icons/grey/view_permissions.svg';
import structureActiveIcon from '../../assets/icons/blue/view_structure.svg';
import structureIcon from '../../assets/icons/grey/view_structure.svg';
import viewIcon from '../../assets/icons/view.png';

export default [
  {
    name: 'View',
    icon: viewIcon,
    items: [
      {
        name: 'view-user-permissions',
        titleKey: 'User Permissions',
        icon: permissionsIcon,
        activeIcon: permissionsActiveIcon,
        isCollapsed: false,
        isActive: false,
        route: '/view/user-permissions',
        roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
      },
      {
        name: 'view-team-permissions',
        titleKey: 'Team Permissions',
        icon: permissionsIcon,
        activeIcon: permissionsActiveIcon,
        isCollapsed: false,
        isActive: false,
        route: '/view/team-permissions',
        roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
      },
      {
        name: 'view-structure',
        titleKey: 'Structure',
        icon: structureIcon,
        activeIcon: structureActiveIcon,
        isCollapsed: false,
        isActive: false,
        route: '/view/structure',
        roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
      },
    ],
  },
];
